module.exports = __webpack_public_path__ + "img/axle_conf_11.ceb44889.jpg";